import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["submitButton"]

  connect() {
    // Check if we have the submit button target
    if (this.hasSubmitButtonTarget) {
      // Initially disable the submit button
      this.disableButton()
    } else {
      console.error("Submit button target not found!")
    }
  }

  toggleButton() {
    const termsCheckbox = this.element.querySelector('#terms')
    
    if (termsCheckbox.checked) {
      this.enableButton()
    } else {
      this.disableButton()
    }
  }

  enableButton() {
    if (!this.hasSubmitButtonTarget) return
    
    this.submitButtonTarget.disabled = false
    this.submitButtonTarget.style.opacity = '1'
    this.submitButtonTarget.style.cursor = 'pointer'
  }

  disableButton() {
    if (!this.hasSubmitButtonTarget) return
    
    this.submitButtonTarget.disabled = true
    this.submitButtonTarget.style.opacity = '0.6'
    this.submitButtonTarget.style.cursor = 'not-allowed'
  }
}
